export default [
  {
    path: '/debug/inviteEmails',
    component: () => import('./InviteEmails.vue'),
    name: 'inviteEmails'
  }
]
